import { type IBuyerChatRoomQuery } from 'application/querySchemas/IBuyerChatRoomQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerChatRoomListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IBuyerChatRoomListClient';
import {
    type IBuyerChatMessagesClient,
    IGetResponse as IBuyerChatMessagesResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerChatMessagesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerChatRoomQuery implements IBuyerChatRoomQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerChatRoomListClient')
        public readonly buyerChatRoomListClient: IBuyerChatRoomListClient,
        @inject('IBuyerChatMessagesClient')
        public readonly buyerChatMessagesClient: IBuyerChatMessagesClient,
    ) {}

    public async fetchRoomList(companyName?: string): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerChatRoomListClient.get({
            token: this.buyerUserToken.get() || '',
            companyName,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchMessages(chatRoomId: number): Promise<IBuyerChatMessagesResponse['data']> {
        const { data, message } = await this.buyerChatMessagesClient.get({
            token: this.buyerUserToken.get() || '',
            chatRoomId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
